import { LOCAL_STORAGE_KEY } from "../../constants/localStorageKeys";
import { useSelector } from "../../redux/hooks";
import { AuthState } from "../../redux/slices/auth/authSlice";
import { RootState } from "../../redux/store";

import useLocalStorage from "./useLocalStorage";

type AuthType = AuthState & {
    csrfToken: string | null;
};

const useAuth = (): AuthType => {
    const authState = useSelector((state: RootState) => state.auth);
    const [getToken] = useLocalStorage(LOCAL_STORAGE_KEY.CSRF_TOKEN);

    return {
        ...authState,
        csrfToken: getToken(),
    };
};

export default useAuth;
